import OT from '@opentok/client';
import UAParser from 'ua-parser-js';

import { updateExtensionInstalled } from 'OPENTOK/actions/browser';
import { initAndPublihshPublisher } from 'OPENTOK/actions/publisher';

const checkExtensionInstalled = () => ((dispatch) => {
  const result = new UAParser().getResult();
  const device = result.device;
  if (device.model || device.type || device.vendor) {
    return dispatch(updateExtensionInstalled(false));
  }

  const browser = result.browser;
  if (browser.name === 'Firefox') {
    dispatch(updateExtensionInstalled(true));
  } else if (browser.name === 'Chrome') {
    dispatch(updateExtensionInstalled(true));
  }
});

export const checkScreenSharingCapability = () => (dispatch, _) => {

  return new Promise((resolve, reject) => {
    OT.checkScreenSharingCapability((response) => {
      if (!response.supported || response.extensionRegistered === false) {
        dispatch(updateExtensionInstalled(false));
        return reject(response);
      }
      resolve(response);
    });
  });
};

export const prepareScreenSharing = () => ((dispatch) => {
  return dispatch(checkExtensionInstalled());
});


export const publishScreen = (sessionId, properties, optEventHandlers) => (dispatch, getState) => {
  return dispatch(initAndPublihshPublisher('screen', sessionId, properties, null, optEventHandlers));
};
